module.exports = __webpack_public_path__ + "static/pic03-353b1721ed8b4ebabb4e33e1257252c0.png";